<template>
    <div class="auditHtml">
        <transition name='left'>
            <div v-show='leftshow' id='leftDiv' class='layout-left' :style='{marginLeft:leftDomMargin, width:leftDomWidth}'>
                <div class="layout_width">
                    <span  v-if="currentDetailInfo.contestTypeDict.templateType == 2" @click="goback()" class="backPdf"><i class="el-icon-back"></i>返回</span>
                    <div v-if="currentDetailInfo.contestTypeDict.templateType == 2" v-html="embedHhtml" style="width: 100%; height: 825px">
                    </div>
                    <!--<div v-if="currentDetailInfo.projectLampparamVo.makingWay == 2" class="PDFHtml">-->
                        <!--<span @click="goback()" class="backPdf"><i class="el-icon-back"></i>返回</span>-->
                        <!--<embed :src="this.ImgPath + currentDetailInfo.projectLampparamVo.pdfPath" width="100%" height="725px">-->
                    <!--</div>-->
                    <el-form v-else>
                        <table class="table">
                            <tbody>
                            <tr class="tr1">
                                <th colspan="8" style="color:#0088cc;text-align:left;font-size:28px;padding-left:15px;">
                                    <div class="backAudit">
                                        <span @click="goback()" ><i class="el-icon-back"></i>返回</span>
                                    </div>
                                    <label class="te">{{currentProject.itemName}}</label> &nbsp;
                                </th>
                            </tr>
                            <tr>
                                <td>
                                    灯参编号：
                                </td>
                                <td>
                                    <span v-bind:class="{activeRed: compObj.lampparamNo}">{{currentDetailInfo.projectLampparamVo.lampparamNo}}</span>
                                </td>
                                <td>
                                    光色类型</td>
                                <td v-html="currentDetailInfo.projectLampparamVo.grayDemandStr"  v-bind:class="{activeRed: compObj.grayDemandStr}" ></td>
                                <td>光束角编号</td>
                                <td>{{currentDetailInfo.projectLampparamVo.angleNo}}</td>
                            </tr>
                            <tr><th colspan="8" style="color:#fff;text-align:center;background-color: #5a63a3;padding:10px;">应用需求</th></tr>
                            <tr>
                                <td width='100'>应用面示意图: </td>
                                <td colspan="3">
                                    <div  class="imgg">
                                        <img :src="'data:image/png;base64,'+currentDetailInfo.projectLampparamVo.contestSketch" alt="">
                                        <input type="hidden" id="contestSketchId" name="contestSketch" value="">
                                        <input type="hidden" id="contestSketchSourceId">
                                    </div>
                                </td>
                                <td>灯具示意图: </td>
                                <td colspan="3">
                                    <div class="imgg">
                                        <img :src="'data:image/png;base64,'+currentDetailInfo.projectLampparamVo.lampSketch" alt="">
                                    </div>
                                    <input type="hidden" id="sketchMapSourceId">
                                </td>
                            </tr>
                            <tr>
                                <td>应用面类型: </td>
                                <td  v-bind:class="{activeRed: compObj.contestTypeString}">
                                    <input type="hidden" name="contestType" value="356">
                                    <label>{{currentDetailInfo.projectLampparamVo.contestTypeString}}</label>
                                </td>
                                <td>反射率: </td>
                                <td  v-bind:class="{activeRed: compObj.albedo}">{{currentDetailInfo.projectLampparamVo.albedo}}</td>
                                <td colspan="4">注：灯具图片仅作参考，灯珠排布及灯具外型由厂家深化，设计方及业主方最终确定,灯具尺寸不大于图示尺寸。</td>
                            </tr>
                            <tr><th colspan="8" style="color:#fff;text-align:center;background-color: #5a63a3;padding:10px;">照明需求</th></tr>
                            <tr>
                                <td>量化指标: </td>
                                <td colspan="7" style="padding:0;">
                                    <div v-if="currentDetailInfo.projectParamindexList.length > 0">
                                        <!-- 应用类型  洗墙、柱子、瓦楞 单侧导光、双侧导光、光电玻璃、自发光线 为一类  暗斑高度是洗墙、立柱、复合面、窗框 -->
                                        <ul class="uls lianghua" v-if="currentDetailInfo.projectLampparamVo.contestTypeString=='洗墙' || currentDetailInfo.projectLampparamVo.contestTypeString=='柱子' || currentDetailInfo.projectLampparamVo.contestTypeString=='瓦楞' || currentDetailInfo.projectLampparamVo.contestTypeString=='自发光线'|| currentDetailInfo.projectLampparamVo.contestTypeString=='单侧导光'|| currentDetailInfo.projectLampparamVo.contestTypeString=='双侧导光' ">
                                            <table border>
                                                <tr>
                                                    <th v-if="currentDetailInfo.projectLampparamVo.colorType == '2'">颜色</th>
                                                    <th width='190'>平均亮度(cd/㎡)</th>
                                                    <th>最大亮度(cd/㎡)</th>
                                                    <th>最小亮度(cd/㎡)</th>
                                                    <th>均匀度</th>
                                                    <th v-if="currentDetailInfo.projectLampparamVo.contestTypeString=='洗墙' || currentDetailInfo.projectLampparamVo.contestTypeString=='柱子' || currentDetailInfo.projectLampparamVo.contestTypeString=='瓦楞'">暗斑高度(m)</th>
                                                </tr>
                                                <tr>
                                                    <td v-if="currentDetailInfo.projectLampparamVo.colorType == '2'">全亮</td>
                                                    <td class="pingjun">
                                                        <el-form-item  v-bind:class="{activeRed: compObj.childFields.brightnessAvgMin}">
                                                            {{currentDetailInfo.projectParamindexList[0].brightnessAvgMin}}
                                                        </el-form-item>
                                                        <span class="xias" v-show="currentDetailInfo.projectParamindexList[0].brightnessAvgMin != ''&&currentDetailInfo.projectParamindexList[0].brightnessAvgMin != null">~</span>
                                                        <el-form-item  v-bind:class="{activeRed: compObj.childFields.brightnessAvgMax}">
                                                            {{currentDetailInfo.projectParamindexList[0].brightnessAvgMax}}
                                                        </el-form-item>
                                                    </td>
                                                    <td>
                                                        <el-form-item  v-bind:class="{activeRed: compObj.childFields.brightnessMax}">
                                                            <span v-show="currentDetailInfo.projectParamindexList[0].brightnessMax != ''&&currentDetailInfo.projectParamindexList[0].brightnessMax != null">≤</span>
                                                            {{currentDetailInfo.projectParamindexList[0].brightnessMax}}
                                                        </el-form-item>
                                                    </td>
                                                    <td>
                                                        <el-form-item v-bind:class="{activeRed: compObj.childFields.brightnessMin}">
                                                            <span v-show="currentDetailInfo.projectParamindexList[0].brightnessMin != ''&&currentDetailInfo.projectParamindexList[0].brightnessMin != null">≥</span>
                                                            {{currentDetailInfo.projectParamindexList[0].brightnessMin}}
                                                        </el-form-item>
                                                    </td>
                                                    <td>
                                                        <el-form-item v-bind:class="{activeRed: compObj.childFields.evenness}">
                                                            <span v-show="currentDetailInfo.projectParamindexList[0].evenness != ''&&currentDetailInfo.projectParamindexList[0].evenness != null">≥</span>
                                                            {{currentDetailInfo.projectParamindexList[0].evenness}}
                                                        </el-form-item>
                                                    </td>
                                                    <td v-if="currentDetailInfo.projectLampparamVo.contestTypeString=='洗墙' || currentDetailInfo.projectLampparamVo.contestTypeString=='柱子' || currentDetailInfo.projectLampparamVo.contestTypeString=='瓦楞'">
                                                        <el-form-item v-bind:class="{activeRed: compObj.childFields.maculaHight}">
                                                            <span v-show="currentDetailInfo.projectParamindexList[0].maculaHight != ''&& currentDetailInfo.projectParamindexList[0].maculaHight != null">≤</span>
                                                            {{currentDetailInfo.projectParamindexList[0].maculaHight}}
                                                            <!-- <span v-show="currentDetailInfo.projectParamindexList[0].maculaHight != ''&& currentDetailInfo.projectParamindexList[0].maculaHight != null">m</span> -->
                                                        </el-form-item>
                                                    </td>
                                                </tr>
                                                <tr v-if="currentDetailInfo.projectLampparamVo.colorType == '2'">
                                                    <td v-bind:class="{activeRed: compObj.childFields.colorTemperatureCustom}">
                                                        {{currentDetailInfo.projectParamindexList[0].colorTemperatureCustom}}
                                                    </td>
                                                    <td class="pingjun">
                                                        <el-form-item v-bind:class="{activeRed: compObj.childFields.brightnessAvgMinCustom}">
                                                            {{currentDetailInfo.projectParamindexList[0].brightnessAvgMinCustom}}
                                                        </el-form-item>
                                                        <span class="xias" v-show="currentDetailInfo.projectParamindexList[0].brightnessAvgMinCustom != ''&& currentDetailInfo.projectParamindexList[0].brightnessAvgMinCustom != null">~</span>
                                                        <el-form-item v-bind:class="{activeRed: compObj.childFields.brightnessAvgMaxCustom}">
                                                            {{currentDetailInfo.projectParamindexList[0].brightnessAvgMaxCustom}}
                                                        </el-form-item>
                                                    </td>

                                                </tr>
                                            </table>

                                        </ul>

                                        <!--窗框、复合面  -->
                                        <ul class="uls lianghua" v-if="currentDetailInfo.projectLampparamVo.contestTypeString=='窗框' || currentDetailInfo.projectLampparamVo.contestTypeString=='复合面' ">


                                            <table  border>
                                                <tr>
                                                    <th v-if="currentDetailInfo.projectLampparamVo.colorType == '2'">颜色</th>
                                                    <th>应用面</th>
                                                    <th width='190'>平均亮度(cd/㎡)</th>
                                                    <th>最大亮度(cd/㎡)</th>
                                                    <th>最小亮度(cd/㎡)</th>
                                                    <th>均匀度</th>
                                                    <th>暗斑高度(m)</th>
                                                </tr>
                                                <tr>
                                                    <td v-if="currentDetailInfo.projectLampparamVo.colorType == '2'" rowspan="2">全亮</td>
                                                    <td>A面</td>
                                                    <td class="pingjun">
                                                        <el-form-item>
                                                            {{currentDetailInfo.projectParamindexList[0].brightnessAvgMin}}
                                                        </el-form-item>
                                                        <span class="xias" v-show="currentDetailInfo.projectParamindexList[0].brightnessAvgMin != ''&&currentDetailInfo.projectParamindexList[0].brightnessAvgMin != null">~</span>
                                                        <el-form-item>
                                                            {{currentDetailInfo.projectParamindexList[0].brightnessAvgMax}}
                                                        </el-form-item>
                                                    </td>
                                                    <td>
                                                        <el-form-item>
                                                            <span v-show="currentDetailInfo.projectParamindexList[0].brightnessMax != ''&&currentDetailInfo.projectParamindexList[0].brightnessMax != null">≤</span>
                                                            {{currentDetailInfo.projectParamindexList[0].brightnessMax}}
                                                        </el-form-item>
                                                    </td>
                                                    <td>
                                                        <el-form-item>
                                                            <span v-show="currentDetailInfo.projectParamindexList[0].brightnessMin != ''&&currentDetailInfo.projectParamindexList[0].brightnessMin != null">≥</span>
                                                            {{currentDetailInfo.projectParamindexList[0].brightnessMin}}
                                                        </el-form-item>
                                                    </td>
                                                    <td>
                                                        <el-form-item>
                                                            <span v-show="currentDetailInfo.projectParamindexList[0].evenness != ''&&currentDetailInfo.projectParamindexList[0].evenness != null">≥</span>
                                                            {{currentDetailInfo.projectParamindexList[0].evenness}}
                                                        </el-form-item>
                                                    </td>
                                                    <td>
                                                        <el-form-item>
                                                            <span v-show="currentDetailInfo.projectParamindexList[0].maculaHight != ''&&currentDetailInfo.projectParamindexList[0].maculaHight != null">≤</span>
                                                            {{currentDetailInfo.projectParamindexList[0].maculaHight}}
                                                            <!-- <span v-show="currentDetailInfo.projectParamindexList[0].maculaHight != ''&&currentDetailInfo.projectParamindexList[0].maculaHight != null">m</span> -->
                                                        </el-form-item>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td>B面</td>
                                                    <td class="pingjun">
                                                        <el-form-item>
                                                            {{currentDetailInfo.projectParamindexList[1].brightnessAvgMin}}
                                                        </el-form-item>
                                                        <span class="xias" v-show="currentDetailInfo.projectParamindexList[1].brightnessAvgMin != ''&&currentDetailInfo.projectParamindexList[1].brightnessAvgMin != null">~</span>
                                                        <el-form-item>
                                                            {{currentDetailInfo.projectParamindexList[1].brightnessAvgMax}}
                                                        </el-form-item>
                                                    </td>
                                                    <td>
                                                        <el-form-item>
                                                            <span v-show="currentDetailInfo.projectParamindexList[1].brightnessMax != ''&&currentDetailInfo.projectParamindexList[1].brightnessMax != null">≤</span>
                                                            {{currentDetailInfo.projectParamindexList[1].brightnessMax}}
                                                        </el-form-item>
                                                    </td>
                                                    <td>
                                                        <el-form-item>
                                                            <span v-show="currentDetailInfo.projectParamindexList[1].brightnessMin != ''&&currentDetailInfo.projectParamindexList[1].brightnessMin != null">≥</span>
                                                            {{currentDetailInfo.projectParamindexList[1].brightnessMin}}
                                                        </el-form-item>
                                                    </td>
                                                    <td>
                                                        <el-form-item>
                                                            <span v-show="currentDetailInfo.projectParamindexList[1].evenness != ''&&currentDetailInfo.projectParamindexList[1].evenness != null">≥</span>
                                                            {{currentDetailInfo.projectParamindexList[1].evenness}}
                                                        </el-form-item>
                                                    </td>
                                                    <td>
                                                        <el-form-item>
                                                            <span v-show="currentDetailInfo.projectParamindexList[1].maculaHight != ''&&currentDetailInfo.projectParamindexList[1].maculaHight != null">≤</span>
                                                            {{currentDetailInfo.projectParamindexList[1].maculaHight}}
                                                            <!-- <span v-show="currentDetailInfo.projectParamindexList[1].maculaHight != ''&&currentDetailInfo.projectParamindexList[1].maculaHight != null">m</span> -->
                                                        </el-form-item>
                                                    </td>
                                                </tr>
                                                <tr v-if="currentDetailInfo.projectLampparamVo.colorType == '2'">
                                                    <td rowspan="2">
                                                        {{currentDetailInfo.projectParamindexList[0].colorTemperatureCustom}}
                                                    </td>
                                                    <td>A面</td>
                                                    <td class="pingjun">
                                                        <el-form-item>
                                                            {{currentDetailInfo.projectParamindexList[0].brightnessAvgMinCustom}}
                                                        </el-form-item>
                                                        <span class="xias" v-show="currentDetailInfo.projectParamindexList[0].brightnessAvgMinCustom != ''&&currentDetailInfo.projectParamindexList[0].brightnessAvgMinCustom != null">~</span>
                                                        <el-form-item>
                                                            {{currentDetailInfo.projectParamindexList[0].brightnessAvgMaxCustom}}
                                                        </el-form-item>
                                                    </td>
                                                </tr>
                                                <tr v-if="currentDetailInfo.projectLampparamVo.colorType == '2'">
                                                    <td>B面</td>
                                                    <td class="pingjun">
                                                        <el-form-item>
                                                            {{currentDetailInfo.projectParamindexList[1].brightnessAvgMinCustom}}
                                                        </el-form-item>
                                                        <span class="xias" v-show="currentDetailInfo.projectParamindexList[1].brightnessAvgMaxCustom != ''&&currentDetailInfo.projectParamindexList[1].brightnessAvgMaxCustom != null">~</span>
                                                        <el-form-item>
                                                            {{currentDetailInfo.projectParamindexList[1].brightnessAvgMaxCustom}}
                                                        </el-form-item>
                                                    </td>
                                                </tr>
                                            </table>

                                        </ul>

                                        <!--正投 -->
                                        <ul class="uls lianghua" v-if="currentDetailInfo.projectLampparamVo.contestTypeString=='正投'">

                                            <table border>
                                                <tr>
                                                    <th v-if="currentDetailInfo.projectLampparamVo.colorType == '2'" width='50'>颜色</th>
                                                    <th width='190'>平均亮度(cd/㎡)</th>
                                                    <th>
                                                        <span v-if="currentDetailInfo.projectLampparamVo.brightnessMax != null && currentDetailInfo.projectLampparamVo.brightnessMax == 'brightnessMax'">最大亮度(cd/㎡)</span>
                                                        <span v-else>A点亮度(cd/㎡)</span>
                                                        <!-- <span v-if="currentDetailInfo.projectParamindexList[0].brightnessMax != null">最大亮度(cd/㎡)</span>
                                                        <span v-else>A点亮度(cd/㎡)</span> -->
                                                    </th>
                                                    <th>均匀度</th>
                                                    <th>b/c亮度比</th>
                                                </tr>
                                                <tr>
                                                    <td v-if="currentDetailInfo.projectLampparamVo.colorType == '2'">全亮</td>
                                                    <td class="pingjun">
                                                        <el-form-item v-bind:class="{activeRed: compObj.childFields.brightnessAvgMin}">
                                                            {{currentDetailInfo.projectParamindexList[0].brightnessAvgMin}}
                                                        </el-form-item>
                                                        <span class="xias" v-show="currentDetailInfo.projectParamindexList[0].brightnessAvgMin != ''&&currentDetailInfo.projectParamindexList[0].brightnessAvgMin != null">~</span>
                                                        <el-form-item v-bind:class="{activeRed: compObj.childFields.brightnessAvgMax}">
                                                            {{currentDetailInfo.projectParamindexList[0].brightnessAvgMax}}
                                                        </el-form-item>
                                                    </td>
                                                    <td>
                                                        <el-form-item>
                                                            <!-- <span v-show="currentDetailInfo.projectParamindexList[0].brightnessMax != ''&&currentDetailInfo.projectParamindexList[0].brightnessMax != null">≤</span> -->
                                                            <span v-bind:class="{activeRed: compObj.childFields.brightnessMax}" v-if="currentDetailInfo.projectLampparamVo.brightnessMax != null && currentDetailInfo.projectLampparamVo.brightnessMax == 'brightnessMax'">
                                                                <span v-show="currentDetailInfo.projectParamindexList[0].brightnessMax != ''&&currentDetailInfo.projectParamindexList[0].brightnessMax != null">≤</span>
                                                                    {{currentDetailInfo.projectParamindexList[0].brightnessMax}}</span>
                                                            <span v-else>
                                                                <span  v-bind:class="{activeRed: compObj.childFields.brightnessA}" v-show="currentDetailInfo.projectParamindexList[0].brightnessA != ''&&currentDetailInfo.projectParamindexList[0].brightnessA != null">≤</span>{{currentDetailInfo.projectParamindexList[0].brightnessA}}</span>
                                                        </el-form-item>
                                                    </td>
                                                    <td>
                                                        <el-form-item>
                                                            <span v-bind:class="{activeRed: compObj.childFields.evenness}" v-show="currentDetailInfo.projectParamindexList[0].evenness != ''&&currentDetailInfo.projectParamindexList[0].evenness != null">≥</span>
                                                            {{currentDetailInfo.projectParamindexList[0].evenness}}
                                                        </el-form-item>
                                                    </td>
                                                    <td>
                                                        <el-form-item  v-bind:class="{activeRed: compObj.childFields.bcBrightnessRatioMin}">
                                                            {{currentDetailInfo.projectParamindexList[0].bcBrightnessRatioMin}} <span class="xias" v-show="currentDetailInfo.projectParamindexList[0].bcBrightnessRatioMin != ''&&currentDetailInfo.projectParamindexList[0].bcBrightnessRatioMin != null">~</span>  {{currentDetailInfo.projectParamindexList[0].bcBrightnessRatioMax}}
                                                        </el-form-item>

                                                    </td>
                                                </tr>
                                                <tr v-if="currentDetailInfo.projectLampparamVo.colorType == '2'">
                                                    <td  v-bind:class="{activeRed: compObj.childFields.colorTemperatureCustom}">
                                                        {{currentDetailInfo.projectParamindexList[0].colorTemperatureCustom}}
                                                    </td>
                                                    <td class="pingjun">
                                                        <el-form-item v-bind:class="{activeRed: compObj.childFields.brightnessAvgMinCustom}">
                                                            {{currentDetailInfo.projectParamindexList[0].brightnessAvgMinCustom}}
                                                        </el-form-item>
                                                        <span class="xias" v-show="currentDetailInfo.projectParamindexList[0].brightnessAvgMinCustom != ''&&currentDetailInfo.projectParamindexList[0].brightnessAvgMinCustom != null">~</span>
                                                        <el-form-item v-bind:class="{activeRed: compObj.childFields.brightnessAvgMaxCustom}">
                                                            {{currentDetailInfo.projectParamindexList[0].brightnessAvgMaxCustom}}
                                                        </el-form-item>
                                                    </td>

                                                </tr>
                                            </table>

                                        </ul>

                                        <!-- 不控光点光源-->
                                        <ul class="uls lianghua" v-if="currentDetailInfo.projectLampparamVo.contestTypeString=='不控光点光源'">

                                            <table border >
                                                <tr>
                                                    <td>颜色</td>
                                                    <th>0°(cd)</th>
                                                    <th>上60°(cd)</th>
                                                    <th>下60°(cd)</th>
                                                    <th>左60°(cd)</th>
                                                    <th>右60°(cd)</th>
                                                </tr>
                                                <tr>
                                                    <td>全亮</td>
                                                    <td>
                                                        <el-form-item v-bind:class="{activeRed: compObj.childFields.level0}">
                                                            <span v-show="currentDetailInfo.projectParamindexList[0].level0 != ''&&currentDetailInfo.projectParamindexList[0].level0 != null">≥</span>
                                                            {{currentDetailInfo.projectParamindexList[0].level0}}
                                                        </el-form-item>
                                                    </td>
                                                    <td>
                                                        <el-form-item v-bind:class="{activeRed: compObj.childFields.verticalUp60}">
                                                            <span v-show="currentDetailInfo.projectParamindexList[0].verticalUp60 != ''&&currentDetailInfo.projectParamindexList[0].verticalUp60 != null">≥</span>
                                                            {{currentDetailInfo.projectParamindexList[0].verticalUp60}}
                                                        </el-form-item>
                                                    </td>
                                                    <td>
                                                        <el-form-item v-bind:class="{activeRed: compObj.childFields.verticalDown60}">
                                                            <span v-show="currentDetailInfo.projectParamindexList[0].verticalDown60 != ''&&currentDetailInfo.projectParamindexList[0].verticalDown60 != null">≥</span>
                                                            {{currentDetailInfo.projectParamindexList[0].verticalDown60}}
                                                        </el-form-item>
                                                    </td>
                                                    <td>
                                                        <el-form-item v-bind:class="{activeRed: compObj.childFields.levelLeft60}">
                                                            <span v-show="currentDetailInfo.projectParamindexList[0].levelLeft60 != ''&&currentDetailInfo.projectParamindexList[0].levelLeft60 != null">≥</span>
                                                            {{currentDetailInfo.projectParamindexList[0].levelLeft60}}
                                                        </el-form-item>
                                                    </td>
                                                    <td>
                                                        <el-form-item  v-bind:class="{activeRed: compObj.childFields.levelRight60}">
                                                            <span v-show="currentDetailInfo.projectParamindexList[0].levelRight60 != ''&&currentDetailInfo.projectParamindexList[0].levelRight60 != null">≥</span>
                                                            {{currentDetailInfo.projectParamindexList[0].levelRight60}}
                                                        </el-form-item>
                                                    </td>
                                                </tr>

                                                <tr v-if="currentDetailInfo.projectLampparamVo.colorType == '2'">
                                                    <td  v-bind:class="{activeRed: compObj.childFields.colorTemperatureCustom}">{{currentDetailInfo.projectParamindexList[0].colorTemperatureCustom}}</td>
                                                    <td v-bind:class="{activeRed: compObj.childFields.level0Custom}">
                                                        ≥ {{currentDetailInfo.projectParamindexList[0].level0Custom}}
                                                    </td>
                                                </tr>
                                            </table>

                                        </ul>
                                        <!-- 控光点光源-->
                                        <ul class="uls lianghua" v-if="currentDetailInfo.projectLampparamVo.contestTypeString=='控光点光源'">

                                            <table  border>
                                                <tr>
                                                    <td>颜色</td>
                                                    <th>0°(cd)</th>
                                                    <th>上30°(cd)</th>
                                                    <th>下60°(cd)</th>
                                                    <th>左60°(cd)</th>
                                                    <th>右60°(cd)</th>
                                                </tr>
                                                <tr>
                                                    <td>全亮</td>
                                                    <td>
                                                        <el-form-item v-bind:class="{activeRed: compObj.childFields.level0}">
                                                            <span v-show="currentDetailInfo.projectParamindexList[0].level0 != ''&&currentDetailInfo.projectParamindexList[0].level0 != null">≥</span>  {{currentDetailInfo.projectParamindexList[0].level0}}
                                                        </el-form-item>
                                                    </td>
                                                    <td class="pingjun">
                                                        <el-form-item v-bind:class="{activeRed: compObj.childFields.verticalUp30}">
                                                            {{currentDetailInfo.projectParamindexList[0].verticalUp30}}
                                                        </el-form-item>
                                                        <span class="xias" v-show="currentDetailInfo.projectParamindexList[0].verticalUp30 != ''&&currentDetailInfo.projectParamindexList[0].verticalUp30 != null">~</span>
                                                        <el-form-item v-bind:class="{activeRed: compObj.childFields.verticalUp30Max}">
                                                            {{currentDetailInfo.projectParamindexList[0].verticalUp30Max}}
                                                        </el-form-item>
                                                    </td>
                                                    <td>
                                                        <el-form-item v-bind:class="{activeRed: compObj.childFields.verticalDown60}">
                                                            <span v-show="currentDetailInfo.projectParamindexList[0].verticalDown60 != ''&&currentDetailInfo.projectParamindexList[0].verticalDown60 != null">≥</span> {{currentDetailInfo.projectParamindexList[0].verticalDown60}}
                                                        </el-form-item>
                                                    </td>
                                                    <td>
                                                        <el-form-item v-bind:class="{activeRed: compObj.childFields.levelLeft60}">
                                                            <span v-show="currentDetailInfo.projectParamindexList[0].levelLeft60 != ''&&currentDetailInfo.projectParamindexList[0].levelLeft60 != null">≥</span> {{currentDetailInfo.projectParamindexList[0].levelLeft60}}
                                                        </el-form-item>
                                                    </td>
                                                    <td>
                                                        <el-form-item v-bind:class="{activeRed: compObj.childFields.levelRight60}">
                                                            <span v-show="currentDetailInfo.projectParamindexList[0].levelRight60 != ''&&currentDetailInfo.projectParamindexList[0].levelRight60 != null">≥</span> {{currentDetailInfo.projectParamindexList[0].levelRight60}}
                                                        </el-form-item>
                                                    </td>
                                                </tr>

                                                <tr v-if="currentDetailInfo.projectLampparamVo.colorType == '2'">
                                                    <td v-bind:class="{activeRed: compObj.childFields.colorTemperatureCustom}">{{currentDetailInfo.projectParamindexList[0].colorTemperatureCustom}}</td>
                                                    <td v-bind:class="{activeRed: compObj.childFields.level0Custom}">
                                                        ≥ {{currentDetailInfo.projectParamindexList[0].level0Custom}}
                                                    </td>
                                                </tr>
                                            </table>

                                        </ul>
                                        <!-- 远视点光源-->
                                        <ul class="uls lianghua" v-if="currentDetailInfo.projectLampparamVo.contestTypeString=='远视点光源'">

                                            <table  border>
                                                <tr>
                                                    <td>颜色</td>
                                                    <th>上30°(cd)</th>
                                                    <th>下45°(cd)</th>
                                                    <th>下10°(cd)</th>
                                                    <th>下10°左60°(cd)</th>
                                                    <th>下10°右60°(cd)</th>
                                                </tr>
                                                <tr>
                                                    <td>全亮</td>
                                                    <td class="pingjun">
                                                        <el-form-item v-bind:class="{activeRed: compObj.childFields.verticalUp30}">
                                                            {{currentDetailInfo.projectParamindexList[0].verticalUp30}}
                                                        </el-form-item>
                                                        <span class="xias" v-show="currentDetailInfo.projectParamindexList[0].verticalUp30 != ''&&currentDetailInfo.projectParamindexList[0].verticalUp30 != null">~</span>
                                                        <el-form-item v-bind:class="{activeRed: compObj.childFields.verticalUp30Max}">
                                                            {{currentDetailInfo.projectParamindexList[0].verticalUp30Max}}
                                                        </el-form-item>
                                                    </td>
                                                    <td class="pingjun">
                                                        <el-form-item v-bind:class="{activeRed: compObj.childFields.down45}">
                                                            {{currentDetailInfo.projectParamindexList[0].down45}}
                                                        </el-form-item>
                                                        <span class="xias" v-show="currentDetailInfo.projectParamindexList[0].down45 != ''&&currentDetailInfo.projectParamindexList[0].down45 != null">~</span>
                                                        <el-form-item v-bind:class="{activeRed: compObj.childFields.down45Max}">
                                                            {{currentDetailInfo.projectParamindexList[0].down45Max}}
                                                        </el-form-item>
                                                    </td>
                                                    <td>
                                                        <el-form-item v-bind:class="{activeRed: compObj.childFields.verticalDown10}">
                                                            <span v-show="currentDetailInfo.projectParamindexList[0].verticalDown10 != ''&&currentDetailInfo.projectParamindexList[0].verticalDown10 != null">≥</span>
                                                            {{currentDetailInfo.projectParamindexList[0].verticalDown10}}
                                                        </el-form-item>
                                                    </td>
                                                    <td>
                                                        <el-form-item v-bind:class="{activeRed: compObj.childFields.vertical10Left60}">
                                                            <span v-show="currentDetailInfo.projectParamindexList[0].vertical10Left60 != ''&&currentDetailInfo.projectParamindexList[0].vertical10Left60 != null">≥</span>
                                                            {{currentDetailInfo.projectParamindexList[0].vertical10Left60}}
                                                        </el-form-item>
                                                    </td>
                                                    <td>
                                                        <el-form-item v-bind:class="{activeRed: compObj.childFields.vertical10Right60}">
                                                            <span v-show="currentDetailInfo.projectParamindexList[0].vertical10Right60 != ''&&currentDetailInfo.projectParamindexList[0].vertical10Right60 != null">≥</span>
                                                            {{currentDetailInfo.projectParamindexList[0].vertical10Right60}}
                                                        </el-form-item>
                                                    </td>
                                                </tr>
                                                <tr v-if="currentDetailInfo.projectLampparamVo.colorType == '2'">
                                                    <td v-bind:class="{activeRed: compObj.childFields.colorTemperatureCustom}">{{currentDetailInfo.projectParamindexList[0].colorTemperatureCustom}}</td>
                                                    <td></td>
                                                    <td v-bind:class="{activeRed: compObj.childFields.verticalDown10Custom}">
                                                        ≥ {{currentDetailInfo.projectParamindexList[0].verticalDown10Custom}}
                                                    </td>
                                                </tr>
                                            </table>

                                        </ul>
                                    </div>
                                </td>
                            </tr>
                            <tr>
                                <td>效果描述: </td>
                                <td colspan="7">{{currentDetailInfo.projectLampparamVo.effectDescription}}</td>
                            </tr>
                            <tr><th colspan="8" style="color:#fff;text-align:center;background-color: #5a63a3;padding:10px;">设备需求</th></tr>
                            <tr>
                                <td>光源类型: </td>
                                <td colspan="3" v-bind:class="{activeRed: compObj.lightType}"> {{currentDetailInfo.projectLampparamVo.lightType}}  </td>
                                <td>工作电压: </td>
                                <td colspan="3" v-bind:class="{activeRed: compObj.workVoltage}"> <span v-show="currentDetailInfo.projectLampparamVo.workVoltage != null && currentDetailInfo.projectLampparamVo.workVoltage != ''">{{currentDetailInfo.projectLampparamVo.workVoltage}} V</span> </td>
                            </tr>
                            <tr>
                                <td>灯具功率: </td>
                                <td colspan="3" v-bind:class="{activeRed: compObj.lampPower }"> <span v-show="currentDetailInfo.projectLampparamVo.lampPower != null && currentDetailInfo.projectLampparamVo.lampPower !=''">≤  {{currentDetailInfo.projectLampparamVo.lampPower}} W</span></td>
                                <td>安装方向: </td>
                                <td colspan="3" v-bind:class="{activeRed: compObj.installDirection }"> {{currentDetailInfo.projectLampparamVo.installDirection}}</td>
                            </tr>
                            <tr>
                                <td rowspan="2">色温色彩: </td>
                                <td rowspan="2" colspan="3">
                                <span v-if="currentDetailInfo.projectLampparamVo.colorType == 1 && currentDetailInfo.projectLampparamVo.colorTemperatureStr != null && currentDetailInfo.projectLampparamVo.colorTemperatureStr != ''">{{currentDetailInfo.projectLampparamVo.colorTemperatureStr}}
                                    <span v-if="currentDetailInfo.projectLampparamVo.colorTemperatureStr > 1000">K</span>
                                </span>
                                    <div  v-else>
                                        <table v-for="(item,index) in currentDetailInfo.projectParamindexList" :key="index">
                                            <tbody>
                                            <tr v-if="index>=detailSkip">
                                                <td>{{item.colorTemperatureStr}}</td>
                                                <td><span v-show="item.colorPower != null && item.colorPower != ''"> ≤ {{item.colorPower}} W</span></td>
                                                <td>{{item.colorCoordinate}}</td>
                                            </tr>
                                            </tbody>
                                        </table>

                                    </div>
                                </td>
                                <td>安装方式: </td>
                                <td colspan="3" v-bind:class="{activeRed: compObj.installType}">{{currentDetailInfo.projectLampparamVo.installType}}</td>
                            </tr>
                            <tr>
                                <td>表面温度: </td>
                                <td colspan="3"  v-bind:class="{activeRed: compObj.surfaceTemperature}">{{currentDetailInfo.projectLampparamVo.surfaceTemperature}}</td>
                            </tr>
                            <tr>
                                <td>灯具颜色: </td>
                                <td colspan="3" v-bind:class="{activeRed: compObj.lampColor}">{{currentDetailInfo.projectLampparamVo.lampColor}}</td>
                                <td>防护等级: </td>
                                <td colspan="3" v-bind:class="{activeRed: compObj.protectLevel}"> {{currentDetailInfo.projectLampparamVo.protectLevel}}</td>
                            </tr>
                            <tr>
                                <td>材质:</td>
                                <td colspan="3" >
                                    <span v-bind:class="{activeRed: compObj.lampQuality}">  {{currentDetailInfo.projectLampparamVo.lampQuality}}</span>
                                    <span v-bind:class="{activeRed: compObj.materialQuality}">  {{currentDetailInfo.projectLampparamVo.materialQuality}}</span>
                                <td>重量:</td>
                                <td colspan="3" v-bind:class="{activeRed: compObj.weight}"><span v-show="currentDetailInfo.projectLampparamVo.weight != null && currentDetailInfo.projectLampparamVo.weight != ''">≤  {{currentDetailInfo.projectLampparamVo.weight}} KG</span></td>
                            </tr>
                            <tr>
                                <td>附件要求: </td>
                                <td colspan="3" v-bind:class="{activeRed: compObj.attachDemand}">{{currentDetailInfo.projectLampparamVo.attachDemand}}</td>
                                <td v-show="currentDetailInfo.projectLampparamVo.controlDigit != null && currentDetailInfo.projectLampparamVo.controlDigit != ''">控制位数: </td>
                                <td colspan="3" v-show="currentDetailInfo.projectLampparamVo.controlDigit != null && currentDetailInfo.projectLampparamVo.controlDigit != ''"  v-bind:class="{activeRed: compObj.controlDigit}">{{currentDetailInfo.projectLampparamVo.controlDigit}}</td>
                            </tr>
                            <tr><th colspan="8" style="color:#fff;text-align:center;background-color: #5a63a3;padding:10px;">控制要求</th></tr>
                            <tr>
                                <td>是否带控: </td>
                                <td colspan="7" v-bind:class="{activeRed: compObj.isControl}" >{{currentDetailInfo.projectLampparamVo.isControl == true ? '是' : "否"}}</td>
                            </tr>
                            <tr>
                                <td>控制协议: </td>
                                <td colspan="7"  v-bind:class="{activeRed: compObj.controlProtocol}">{{currentDetailInfo.projectLampparamVo.controlProtocol}}
                                    <!-- {{currentDetailInfo.projectLampparamVo.controlProtocol2}} -->
                                </td>
                            </tr>
                            <tr>
                                <td>动态效果: </td>
                                <td colspan="7" v-bind:class="{activeRed: compObj.colorDemand}">{{currentDetailInfo.projectLampparamVo.colorDemand}}</td>
                            </tr>
                            <tr>
                                <td>其他要求: </td>
                                <td colspan="7" v-bind:class="{activeRed: compObj.otherDemand}">{{currentDetailInfo.projectLampparamVo.otherDemand}}</td>
                            </tr>
                            </tbody>
                        </table>
                    </el-form>
                </div>
            </div>
        </transition>
        <div class='layout-area'  :class="leftshow == true ? 'active':''">
            <div @click='slide1'>
                <i v-if='leftshow' class="el-icon-d-arrow-left"></i>
                <i  v-if='!leftshow' class="el-icon-d-arrow-right"></i>
            </div>
        </div>
        <div id='proxyDiv' class='layout-proxy' @mousedown.prevent='dragStart1' :style='{left:proxyDomLeft}'></div>
        <div id='centerDiv' class='layout-center' :style='{width:centerDomWid}'>
            <div class="top">
                <div class="list_Se_btn">
                <span @click="showSetDiv()">
                  <img src="@/assets/images/icon9_27.png" alt="">列表显示项
                </span>
                </div>
                <selectLampTable v-on:tableOver="tableOver" v-on:setTotalCount="setTotalCount" v-on:contrastShow="contrastShow" ref="lampTable"></selectLampTable>
            </div>
            <div class="bom">
                <el-form ref="form" label-width="100px">
                    <el-form-item label="是否通过审核">
                        <el-radio-group v-model="submitAuditForm.flag">
                            <el-radio label="1">通过</el-radio>
                            <el-radio label="2">驳回</el-radio>
                        </el-radio-group>
                    </el-form-item>
                    <el-form-item label="审核原因" :rules="[{ required: true}]">
                        <el-input type="textarea" v-model="submitAuditForm.auditReson"></el-input>
                    </el-form-item>
                    <el-form-item>
                        <el-button @click="goback()">取 消</el-button>
                        <el-button type="primary" @click="auditSubmit()">提 交</el-button>
                    </el-form-item>
                </el-form>
            </div>
        </div>
        <selectLampDetail ref="detail"></selectLampDetail>
    </div>
</template>
<script>
    import selectLampDetail from '@/views/component/selectLampDetail.vue'
    import selectLampTable from '@/views/component/selectLampTable.vue'

    import $ from 'jquery'
    import Swiper from 'swiper';
    import 'swiper/dist/css/swiper.min.css';
    export default {
        data(){
            return{
                embedHhtml: '', //pdf内容
                showMorelistShow2:false,
                showMorelistShow:false,
                sortRule:{prop:null,order:null},
                tabData:'', //table排序前的数据
                detailSkip:1,
                detailInfo:{ //详情模型
                    contestDetection:{
                    },
                    contestStorageExaVo:{
                    },
                    storageContestDetectionList:[]
                },
                tableData:[],
                totalCount:0,
                submitAuditId:0,
                currentDetailInfo:{
                    projectLampparamVo:{},
                    projectParamindexList:[]
                },
                leftshow:true,
                layoutX:807,
                leftDomMargin:'0px',
                leftDomWidth:'807px',
                centerDomWid:'calc(100% - 20px -800px)',
                proxyDomLeft:'816px',
                tableAuditHtml:[{
                    name:''
                }],
                submitAuditForm:{
                    flag:'1',
                    auditReson:''
                },
                currentProject:{},
                request:{
                    lampShape : '', //从灯具示意图中获取灯具形状
                    lampIdsStr:'',
                    page:1,
                    rows:20,
                    contestTypeId:'', //应用面
                    dataTypeStr:'', //典型应用场景检测、项目检测、厂家标称值
                    isAudit: 1, //审核通过的
                    brandIds:'',//灯具品牌
                    colorFlag:'', //
                    dictIdLtype:'',//lamptype
                    powerMax:'',

                    sH:'', //search H
                    sW:'',//search W
                    sW1:'', //search sw1
                    sW2:'', //search sw2
                    lumSize:'', // search d
                    lumSizeMax:'',

                    priceMax:'',
                    priceMin:'',

                    longNs:'',//长
                    widthNs:'',//宽
                    heightNs: '', //高
                    lightnessAveMin: '', //平均亮度min
                    lightnessAveMax: '', //平均亮度max
                    lightnessMaxMax:'', //最大亮度大值
                    lightnessStart:'', //最小亮度
                    evennessMin:'', //均匀度

                    lightnessAveMinA:'',
                    lightnessAveMaxA:'',
                    lightnessMaxMaxA:'',
                    lightnessStartA:'',
                    evennessMinA:'',
                    lightnessAveMinB:'',
                    lightnessAveMaxB:'',
                    lightnessMaxMaxB:'',
                    lightnessStartB:'',
                    evennessMinB:'',

                    lightIntensity1:'', //>=0
                    lightIntensity2:'',
                    lightIntensity3Min:'',
                    lightIntensity3Max:'',
                    lightIntensity4:'',
                    lightIntensity5:'',
                    lightIntensity6Min:'',
                    lightIntensity6Max:'',
                    lightIntensity7:'',
                    lightIntensity8:'',
                    lightIntensity9:'',
                    lightIntensity10:'',

                    powerWeight: '',  //权重排序 功率
                    lightnessAveWeight: '', //权重排序 平均亮度
                    lightnessWeight: '',  //权重排序 最小亮度
                    lightnessMaxWeight: '', //权重排 序最大亮度
                    evennessWeight:'', //权重排序 亮度均匀度
                    anbanHeightWeight:'', //权重排序 暗斑高度
                    priceWeight: '', //权重排序 价格
                    diffArray:[]
                },
                checkboxModel:[],
                showPic:false,
                showPicUrl:'',
                compObj:{} //灯参对比对象

            }
        },
        components:{
            selectLampDetail,
            selectLampTable
        },
        methods:{

            contrastShow(row) {
                this.$refs.detail.show(row.id)
            },
            showSetDiv(){
                this.$refs.lampTable.showSetDiv()
            },
            tableOver(){
                this.search(1)
            },
            downloadUrl(url){
                window.open(this.ImgPath + url)
            },
            sortChange(item){
                //如果不排序了，就恢复到最初的状态
                if(item.order == null){
                    this.tableData = this.tabData;
                }else{
                    this.request.sort = item.prop.replace('projectLampparamVo.','')
                    this.request.order = (item.order == 'ascending'? 'asc' : 'desc')
                    this.search(1)
                }
                this.sortRule.order = item.order;
                this.sortRule.prop = item.prop;
            },
            viewPicture(url){
                this.showPic = true
                this.showPicUrl = url
                if(url) {
                    url.stopPropagation ? url.stopPropagation(): url.cancelBubble = true;
                }

            },
            clickRow(item){
                this.$refs.detail.show(item.id)
            },
            settableCheckbox(val){
                this.checkboxModel = val
            },
            search(){
                let self = this
                this.request.page=1
                this.setRequestInfo()
                this.$refs.lampTable.search(2,this.currentDetailInfo.projectLampparamVo.contestTypeString,this.request)
            },
            setTotalCount(data){
                this.tableData = data.tableData
                this.totalCount = data.totalCount
            },
            setRequestInfo(){
                let self = this
                this.request.dataTypeStr = '1,2'
                //增加默认根据灯具示意图初始化灯参要求形状字段
                if (this.currentDetailInfo.lampSketch!=null && this.currentDetailInfo.lampSketch.lampShape!='') {
                    this.request.lampShape = this.currentDetailInfo.lampSketch.lampShape
                }
                var info = this.currentDetailInfo.projectLampparamVo;
                var list = this.currentDetailInfo.projectParamindexList;
                this.request.lampIdsStr = info.lampType
                this.request.voltage = info.workVoltage
                this.request.brandIds = info.recommendBrand
                this.request.contestTypeId = info.contestType
                this.request.powerMax = info.lampPower

                let getDiffData = info.refDetectionIds?info.refDetectionIds:'';
                let getDiffArray = getDiffData.split(',');
                this.request.diffArray =getDiffArray;
                // this.request.colorFlag = info.colorType
                this.request.h = info.contestH
                this.request.w = info.contestW
                this.request.w1 = info.contestW1
                this.request.w2 = info.contestW2
                this.request.colorFlag = info.grayDemand
                this.request.projectId = this.$route.query.projectId
                if(this.request.contestTypeId == 357){
                    this.request.lumSize = info.lumSize
                }else{
                    this.request.lumSizeMax = info.lumSize
                } //含灯距离为精确查找

                this.request.albedo = info.albedo

                this.request.heightNs = info.lampHeight
                this.request.widthNs = info.lampWidth
                this.request.longNs = info.lampLong
                if(self.currentDetailInfo.projectLampparamVo.contestTypeString == '窗框' || self.currentDetailInfo.projectLampparamVo.contestTypeString == '复合面' && list.length > 1){
                    this.request.lightnessAveMinA = list[0].brightnessAvgMin
                    this.request.lightnessAveMaxA = list[0].brightnessAvgMax
                    this.request.lightnessMaxMaxA = list[0].brightnessMax
                    this.request.lightnessStartA = list[0].brightnessMin
                    this.request.evennessMinA = list[0].evenness

                    this.request.lightnessAveMinB = list[1].brightnessAvgMin
                    this.request.lightnessAveMaxB = list[1].brightnessAvgMax
                    this.request.lightnessMaxMaxB = list[1].brightnessMax
                    this.request.lightnessStartB = list[1].brightnessMin
                    this.request.evennessMinB = list[1].evenness
                }else if(list.length > 0){
                    this.request.lightnessAveMin = list[0].brightnessAvgMin
                    this.request.lightnessAveMax = list[0].brightnessAvgMax
                    this.request.lightnessMaxMax = list[0].brightnessMax
                    this.request.lightnessStart = list[0].brightnessMin
                    this.request.evennessMin = list[0].evenness
                    this.request.brightnessAMax = list[0].brightnessA

                    this.request.lightIntensity1Min=list[0].level0 //>=0
                    this.request.lightIntensity2Min=list[0].levelRight60
                    this.request.lightIntensity3Min=list[0].down45
                    this.request.lightIntensity3Max=list[0].down45Max
                    this.request.lightIntensity4Min=list[0].verticalDown60
                    this.request.lightIntensity5Min=list[0].levelLeft60
                    this.request.lightIntensity6Min=list[0].verticalUp30
                    this.request.lightIntensity6Max=list[0].verticalUp30Max
                    this.request.lightIntensity7Min=list[0].verticalDown10
                    this.request.lightIntensity8Min=list[0].verticalUp60
                    this.request.lightIntensity9Min=list[0].vertical10Left60
                    this.request.lightIntensity10Min=list[0].vertical10Right60

                }


            },
            //是否通过审核
            auditSubmit(){
                var count = this.tableData.length
                let self = this
                var flag = this.submitAuditForm.flag == 1
                var no = this.currentDetailInfo.projectLampparamVo.lampparamNo
                var ts = flag ? "通过" : "驳回"
                var str = '您确定'+ts+'灯参'+no+'吗？'
                if(count < 3 && flag){
                    str = '符合数量较少，是否确认审核通过灯参'+this.currentDetailInfo.projectLampparamVo.lampparamNo+'？'
                }
                this.$confirm(str,'提示',{
                    confirmButtonText: '确认',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(()=>{
                    //flag 1 通过 2退回  auditReson 审核原因
                    this.$http.postObj("/api/lampparams/auditSubmit/"+this.submitAuditId,this.submitAuditForm,function(res){
                        if(res.success){
                            self.$message({
                                message: "操作成功！",
                                type: "success"
                            });
                            self.goback()
                        }else{
                            self.$message.error(res.data)
                        }
                    })
                }).catch(()=>{});

            },
            initData(){
                this.showDetail()
            },
            showDetail(){
                let self = this
                this.submitAuditId = this.$route.query.id
                var id = this.$route.query.id;
                var projectId = this.$route.query.projectId

                //加载项目信息
                this.$http.get('/api/projects/view/'+projectId,{},function(res){
                    self.currentProject = res.data
                })
                this.$http.get('/api/lampparams/view/'+this.submitAuditId,{isAudit:true},function(res){
                    if(res.success){
                        self.currentDetailInfo = res.data
                        //如果从典型应用制作的灯参，则需要灯参选项是否有变动
                        //特殊模板请求pdf

                        if(self.currentDetailInfo.contestTypeDict.templateType == '2' ){
                            let pdfSrc = self.$http.getSignUrl('/api/previewPdf', {
                                fileName: self.currentDetailInfo.projectLampparamVo.pdfPath,
                                token: self.$store.state.token,
                            });
                            self.embedHhtml = `<embed src="${pdfSrc}" class="pdf" style="width: 100%;height: 100%">`
                        }

                        // if(self.currentDetailInfo.projectLampparamVo.rootIn == '1'){
                        self.$http.get('/api/lampparams/standLampCompare/'+id,{},function(res){
                            if(res.success){
                                self.compObj = res.data.fields
                            }
                        })
                        //}
                        //self.search()
                        if(self.currentDetailInfo.projectLampparamVo.contestTypeString == '窗框' || self.currentDetailInfo.projectLampparamVo.contestTypeString == '复合面'){
                            self.detailSkip = 2
                        }else{
                            self.detailSkip = 1
                        }
                        if(self.currentDetailInfo.projectLampparamVo.contestTypeString == '控光点光源' || self.currentDetailInfo.projectLampparamVo.contestTypeString == '不控光点光源' || self.currentDetailInfo.projectLampparamVo.contestTypeString == '远视点光源'){
                            self.loadShowhideCloumn(self.currentDetailInfo.projectLampparamVo.contestTypeString)
                        }




                    }
                })
            },
            loadShowhideCloumn(val){
                this.columnShowHideList=
                    [
                        {
                            label:'灯具图',
                            value:true
                        },
                        {
                            label:'配光曲线',
                            value:true
                        },
                        {
                            label:'品牌',
                            value:true
                        },
                        {
                            label:'灯具类型',
                            value:true
                        },
                        {
                            label:'样品名称',
                            value:false
                        },
                        {
                            label:'光源类型',
                            value:false
                        },
                        {
                            label:'标称功率',
                            value:false
                        },
                        {
                            label:'标称电压',
                            value:false
                        },
                        {
                            label:'标称色温',
                            value:false
                        },
                        {
                            label:'灯具尺寸(含支架mm)',
                            value:false
                        },
                        {
                            label:'灯具尺寸(不含支架mm)',
                            value:false
                        },
                        {
                            label:'检测模式',
                            value:false
                        },
                        {
                            label:'实测功率(W)',
                            value:true
                        },
                        {
                            label:'功率因数',
                            value:false
                        },
                        {
                            label:'实测电压(V)',
                            value:false
                        },
                        {
                            label:'实测光束角',
                            value:true
                        },
                        {
                            label:'实测色温(K/nm)',
                            value:false
                        },
                        {
                            label:'色容差(SDCM)',
                            value:false
                        },
                        {
                            label:'Ra',
                            value:false
                        },
                        {
                            label:'R9',
                            value:false
                        },
                        {
                            label:'光通量(lm)',
                            value:false
                        },
                        {
                            label:'峰值光强(cd)',
                            value:false
                        },
                        {
                            label:'测试角度',
                            value:false
                        },
                        {
                            label:'应用类型',
                            value:false
                        },
                        {
                            label:'H',
                            value:false
                        },
                        {
                            label:'W',
                            value:false
                        },
                        {
                            label:'W1',
                            value:false
                        },
                        {
                            label:'W2',
                            value:false
                        },
                        {
                            label:'D',
                            value:false
                        },
                        {
                            label:'平均亮度(cd/㎡)',
                            value:false
                        },
                        {
                            label:'最大亮度(cd/㎡)',
                            value:false
                        },
                        {
                            label:'最小亮度(cd/㎡)',
                            value:false
                        },
                        {
                            label:'亮度均匀度',
                            value:false
                        },
                        {
                            label:'0°',
                            value:true
                        },
                        {
                            label:'上30°',
                            value:true
                        },
                        {
                            label:'下60°',
                            value:true
                        },
                        {
                            label:'左60°',
                            value:true
                        },
                        {
                            label:'右60°',
                            value:true
                        },
                        {
                            label:'a点亮度',
                            value:false
                        },
                        {
                            label:'b点亮度',
                            value:false
                        },
                        {
                            label:'c点亮度',
                            value:false
                        },
                        {
                            label:'参考价',
                            value:true
                        },
                    ]
                if(val=='不控光点光源'){
                    this.columnShowHideList[33] =  {
                        label:'0°',
                        value:true
                    }
                    this.columnShowHideList[34] = {
                        label:'上60°',
                        value:true
                    },
                        this.columnShowHideList[35] = {
                            label:'下60°',
                            value:true
                        },
                        this.columnShowHideList[36] = {
                            label:'左60°',
                            value:true
                        },
                        this.columnShowHideList[37] = {
                            label:'右60°',
                            value:true
                        }
                } else if(val=='远视点光源'){
                    this.columnShowHideList[33] =  {
                        label:'上30°',
                        value:true
                    }
                    this.columnShowHideList[34] = {
                        label:'下45°',
                        value:true
                    },
                        this.columnShowHideList[35] =  {
                            label:'下10°',
                            value:true
                        },
                        this.columnShowHideList[36] = {
                            label:'下10° 左60°',
                            value:true
                        },
                        this.columnShowHideList[37] = {
                            label:'下10° 右60°',
                            value:true
                        }
                }
            },
            goback(){
              history.back()
                //修改交互为新页面打开则关闭
                //window.close();

            },
            slide1(){
                this.leftshow = !this.leftshow;
                let that = this;
                if(!this.leftshow){ //隐藏左侧div
                    that.proxyDomLeft = -that.layoutX + 'px';
                    that.leftDomMargin = -that.layoutX + 'px';
                    that.centerDomWid = 'calc(100% - 20px)';
                }else{
                    setTimeout(function(){
                        that.proxyDomLeft = that.layoutX + 'px';
                        that.leftDomMargin = '0px';
                        that.centerDomWid = 'calc(100% - 20px - '+that.layoutX+'px)';
                    },30)

                }
            },
            /*拖拽*/
            dragStart1(e){
                let that = this;//保存this到that
                e.target.style.opacity = .8;
                /*当鼠标在拖动div按下时绑定鼠标移动事件*/
                document.onmousemove = function(event){
                    that.proxyDomLeft = event.clientX + 'px';
                    //拖动时更改代理div的位置，跟随鼠标运动
                }
                document.onmouseup = function(event){
                    that.layoutX = event.clientX; //保存鼠标抬起的位置，
                    e.target.style.opacity = 0; //代理div不可见
                    that.leftDomWidth = event.clientX + 'px';
                    that.centerDomWid = 'calc(100% - 20px - '+event.clientX+'px)';
                    //还原事件
                    document.onmousemove = null;
                    document.onmouseup = null;
                }
            }
        },
        created(){
            this.initData()
        }
    }
</script>

<style rel="stylesheet/scss" lang="scss">

    .activeRed{
        color: #ff92a3;
    }
    .swiper-button-white{
        background: rgba(0, 0, 0, 0.3);
        top:auto !important;
        margin-top: 0 !important;
        bottom: 0;
        height: 50px;
        background-size: 12px !important;
        background-position: center !important;
        background-repeat: no-repeat !important;
    }
    .gallery-top-box{
        height: 100%;
    }
    .gallery-thumbs-box{
        .gallery-thumbs2{
            .swiper-slide{
                border-radius: 4px;
                overflow: hidden;
                &.swiper-slide-thumb-active::after{
                    content: '';
                    position: absolute;
                    width: 100%;
                    height: 100%;
                    left: 0;
                    top:0;
                    background-color: rgba(32, 140, 198, 0.5);
                }

            }
        }
    }
    .shehes th{
        background: #eff5ff;
    }
    .te{
        color: #5a63a3;
        font-size: 16px;
        font-weight: bold
    }
    .ksdx{
        display: inline-block
    }
    .uls.lianghua{
        table{
            width: 100%;
            text-align: center;
            th{
                background: #eff5ff;
                text-align: center;
                height: 50px;
                text-align: center;
                padding: 5px;
                border-right: solid 1px rgba(184, 205, 217, 0.4);
            }
            .el-form-item{margin-bottom: 0}
            td{
                background:#fff !important;
                &.pingjun{
                    .el-form-item{

                        margin-right: 0;
                        display: inline-block;
                        margin-bottom: 0;
                    }

                }
            }
        }
    }
    .auditHtml{
        overflow: hidden;
        margin-top: 88px;
        position: relative;
        .backAudit{
            color: #999999;
            font-size: 18px;
            background: none;
            cursor: pointer;
            display: inline-block;
            margin-right: 20px;
            span{
                font-weight: 400
            }
            i{
                width: 18px;
                height: 18px;
                line-height: 18px;
                color: #5a63a3;
                display: inline-block;
                border-radius: 50%;
                border: 1px solid #5a63a3;
                margin-right: 5px;
                position: relative;
                top: 2px;
            }
        }
        .layout-left{
            background: #fff;
            margin: 15px 0;
            overflow: auto;
            float: left;
        }
        .layout-center{
            width: calc(100% - 830px);
            width: -webkit-calc(100% - 830px);
            float: right;
            background: #fff;
            margin: 15px 0;
            padding: 20px;
            .bom{
                margin-top: 30px;
            }
        }
        .layout-area{
            width:20px;
            height:44px;
            text-align: center;
            background: #fff;
            float:left;
            position:relative;
            top: 17px;
            left: -5px;
            z-index: 5;
            line-height: 44px;
            cursor: pointer;
        }
        .layout-area.active{
            left: -20px;
        }
        .layout-proxy {
            position: absolute;
            cursor: w-resize;
            opacity: 0;
            left: 810px;
            width: 10px;
            height: 100%;
        }
        .lianghua{
            tr td{
                .el-form-item{
                    .el-form-item__content{
                        .el-input__inner{
                            padding:0 5px;
                        }
                    }
                }
            }
        }
        .layout_width{
            margin: auto;
            width: 807px;
            min-width: 807px;
            transition: all 0.2s;
            -moz-transition: all 0.2s;
            -webkit-transition: all 0.2s;
            -o-transition: all 0.2s;
            margin: auto;
            overflow: hidden;
            padding: 0;
            top: 0;
            z-index: 99;
            background: #fff;
            border: 1px solid rgba(181, 181, 181, 0.4);
            border-top: none;
        }
        .table{
            margin: 0 auto;
            padding: 0;
            border-collapse: collapse;
            width: 100%;
            tr {
                height: 20px;
                border: 1px solid #d0d0d2;
                td {
                    background: #eff5ff;
                    width: 100px;
                    border: 1px solid #d0d0d2;
                    padding: 5px;
                    &:nth-child(2n) {
                        padding: 5px;
                        background: none;
                    }
                    .imgg{
                        width: 300px;
                        height: 200px;
                        line-height: 200px;
                        margin: auto;
                    }
                }
                &.tr1{
                    height: 45px;
                }
            }
        }
    }
    .contrast{
        position: fixed;
        top: 0;
        bottom: 0;
        left: 0;
        right: 0;
        text-align: center;
        background: rgba(0,0,0,0.5);
        z-index: -1;
        opacity: 0;
        display: none;
        &.active{
            opacity: 1;
            z-index: 99;
            display: block;
        }
        .contrast_cont{
            display: inline-block;
            max-width: 1100px;
            max-height: 90vh;
            width: 100%;
            padding-bottom: 10px;
            vertical-align: middle;
            background-color: #fff;
            border-radius: 4px;
            border: 1px solid #ebeef5;
            font-size: 18px;
            box-shadow: 0 2px 12px 0 rgba(0,0,0,.1);
            text-align: left;
            overflow: hidden;
            backface-visibility: hidden;
            padding: 0;
            .lt_rt{
                display: box;
                display: -webkit-box;
                display: -moz-box;
                display: -o-box;
                position: relative;
                .rt_ct{
                    width: 50%;
                    padding: 10px 20px;
                    position: relative;
                    table{
                        width: 100%;
                        td{
                            font-size: 14px;
                            text-align: center;
                        }
                    }
                    .el-icon-close{
                        float: right;
                        font-size: 20px;
                        cursor: pointer;
                        position: relative;
                    }
                    .p1{
                        font-size: 12px;
                        margin-bottom: 5px;
                    }
                    .cont{
                        position: relative;
                        margin-top: 18px;
                        .set{
                            position: absolute;
                            text-align: right;
                            right: 0;
                            top: 70px;
                            color: #333333;
                        }
                        .xian{
                            color: #333333;
                            position: relative;
                            padding: 0px 0 6px;
                            border-bottom: 2px solid #eeeeee;
                            span{
                                position: absolute;
                                right: 0;
                                top: 0;
                                font-size: 14px;
                                cursor: pointer;
                            }
                            .xian_rt{
                                float: right;
                                font-size: 14px;
                                position: absolute;
                                right: 0;
                                top: 0;
                                span{
                                    position: initial;
                                    color: #208cc6;
                                }
                            }
                        }
                        ul{
                            margin: 1rem 0 2rem;
                            position: relative;
                            li{
                                width: 50%;
                                display: inline-block;
                                font-size: 12px;
                                margin-bottom: 2px;
                                color: #333333;
                                line-height: 1em;
                                span:first-child{
                                    color: #000;
                                    font-weight: bold
                                }
                            }
                        }
                    }
                    .bottm{
                        text-align: center;
                        margin-top: 20px;
                        button{
                            background-color: #eeeeee;
                            font-size: 12px;
                            padding: 7px 15px;
                        }

                    }
                }
                .lt_ct{
                    width: 50%;
                    background-color: #f8f8f8;
                    padding: 20px;
                    position: relative;
                    .top{
                        margin-bottom: 15px;
                        span{
                            color: #666666;
                            margin-right: 12px;
                            &:nth-child(1),&:nth-child(3){
                                color: #208cc6;
                            }
                            &:last-child{
                                float: right;
                                font-size: 12px;
                                margin-right:0;
                                img{
                                    position: relative;
                                    top: 2px;
                                    margin-right: 5px;
                                    display: inline-block;
                                }
                            }
                        }
                    }
                    .cents{
                        position: relative;
                        .cents_s{
                            height: 44vh;
                        }
                        .cout_list{
                            height: 100%;
                            .gallery-thumbs-box,.swiper-container,.swiper-wrapper{
                                height: 100%;
                            }
                            // img{
                            //    max-height: 44vh;
                            // }
                        }
                        .cent_ss{
                            overflow: auto;
                            margin-top: 16px;
                            padding: 0 38px;
                            li{
                                display: inline-block;
                                border-radius: 4px;
                                overflow: hidden;
                                margin-right: 10px;
                            }
                        }
                    }
                    .bom{
                        margin-top: 20px;
                        text-align: center;
                    }
                }
            }
        }
    }
    .lianghua tr td .el-form-item.anban .el-form-item__content .el-input__inner{
        background-color:#fff;
    }
    .dep{
        position: relative;
        cursor: pointer;
    }
    .pingjun_s{
        .el-form-item{
            width: auto;
            display: inline-block;
            .el-form-item__content{
                display: inline-block;
            }
        }
    }
    .PDFHtml{
        .backPdf{
            padding: 10px 20px;
            display: inline-block;
            cursor: pointer;
            i{
                width: 18px;
                height: 18px;
                line-height: 18px;
                color: #5a63a3;
                display: inline-block;
                border-radius: 50%;
                border: 1px solid #5a63a3;
                margin-right: 5px;
                position: relative;
            }
        }
    }
    .dynamic-class{
        padding: 0;
        .el-button--mini{
            top: 7px;
            position: absolute;
            right: 30px;
            color: #000;
            font-size: 18px;
        }
        .tp{
            background-color: #5a63a3;
            color: #fff;
            padding: 15px 25px;
        }
        .el-icon-error{
            color: #fff;
            font-size: 20px;
        }
        .contcheck{
            width: 770px;
            padding: 2% 5% 5%;
            .tishix{
                padding: 6px 15px;
                border-radius: 3px;
                background: rgba(90, 99, 163,0.2);
            }
            //  .li_list{
            //      display: block;
            //  }
            .el-form-item{
                margin-bottom: 0;
            }

            .li_list{
                width: 25%;
                float: left;
                margin-right: 0;
                padding: 5px 0;
                input{
                    position: relative;
                    top: 2px;
                    margin-right: 3px;
                }
            }

            .el-checkbox-group{
                width: 100%;
                padding: 15px 25px;
                display: inline-block;
                .el-checkbox{
                    width: 25%;
                    float: left;
                    margin-right: 0;
                }
            }
            .btn{
                padding: 0 25px;
                text-align: center;
                button{
                    padding: 7px 25px;
                    background-color: #5a63a3;
                    border-radius: 4px;
                }
            }
        }
    }
    #centerDiv .list_S{
        .el-button{
            border: none;
            padding: 5px;
            margin-bottom: 5px;
            img{
                display: inline-block;
                position: relative;
                top: 5px;
                margin-right: 5px;
            }
        }
    }
    .showMorelist2{
        padding: 0;
        width: 780px;
        .el-form-item{width: 100%;
            .el-form-item__content{
                width: 100%;
            }

        }
        .cont{
            width: 100%;
            .conts{
                overflow: hidden;
            }
        }
        .el-dialog__header{
            position: absolute;
            z-index: 99;
            width: 100%;
            .el-dialog__headerbtn{
                background-color:#fff;
                i{
                    color: #5a63a3 !important;
                }
            }
        }
        .el-dialog__body{
            padding: 0
        }
        .el-button--mini {
            position: absolute;
            right: 30px;
            color: #000;
            font-size: 18px;
            top: 7px;
            i{
                font-size: #fff;
            }
        }
        .tp {
            background-color: #5a63a3;
            color: #fff;
            padding: 15px 25px;
        }
        .contcheck{
            width: 770px;
            padding: 5%;
            .el-form-item__content .li_list {
                width: 25%;
                float: left;
                margin-right: 0;
            }
        }
    }
    .list_Se_btn{
        height: auto;
        border:none;
        span{
            padding: 5px 5px 5px 0;
            display: inline-block;
            cursor: pointer;
        }
        img{
            display: inline-block;
            margin-right: 5px;
            position: relative;
            top: 5px;
        }
    }
</style>
